import { Box, Typography } from '@mui/material';
import MerchantOrdersListing from './merchant-orders-listing/merchant-orders-listing';
import Grid from '@mui/material/Unstable_Grid2';
import CreateEntityDrawer from '../../common/create-entity-drawer/create-entity-drawer';
import MerchantCreateOrderForm from './merchant-create-order-form/merchant-create-order-form';

import { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';

function MerchantOrders() {
  const { user, config } = useContext(AuthContext);

  return <MerchantOrdersListing />;
}

export default MerchantOrders;
